import { Button, Tooltip } from "antd";
import { motion } from "framer-motion";

const DefaultIcon = (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="10" y="3" width="4" height="18" rx="1" />
    <rect x="3" y="10" width="18" height="4" rx="1" />
  </svg>
);

const MotionIconButton = ({
  text,
  tooltip,
  icon = DefaultIcon, // Set default icon here
  onClick,
  size = "large",
  color = "from-indigo-400 to-purple-900"
}) => {
  return (
    <Tooltip title={tooltip} placement="top">
      <motion.div
        whileHover={{ scale: 1.2, rotate: 10 }}
        whileTap={{ scale: 0.9 }}
      >
        <Button
          type="primary"
          size={size}
          icon={icon}
          shape="circle"
          onClick={onClick}
          className={`bg-gradient-to-r ${color} text-white bg-[#3f3fc2]
                     shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1`}
        >
          {text}
        </Button>
      </motion.div>
    </Tooltip>
  );
};

export default MotionIconButton;
